import { Link } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@tonic/shared/components/ui';
import { Badge } from '@tonic/shared/components/ui';
import { Button } from '@tonic/shared/components/ui';
import { ArrowUpDown } from 'lucide-react';
import { cn } from '@tonic/shared/utils/lib/utils';
import PropTypes from 'prop-types';

export function ProductsTable({ products, onSort, sortConfig }) {
  const renderSortIcon = (column) => {
    if (sortConfig?.field !== column) {
      return <ArrowUpDown className="ml-2 h-4 w-4" />;
    }
    return (
      <ArrowUpDown 
        className={cn(
          "ml-2 h-4 w-4",
          sortConfig.direction === 'asc' ? 'rotate-0' : 'rotate-180'
        )}
      />
    );
  };

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>
            <Button 
              variant="ghost" 
              onClick={() => onSort('sku')}
              className={cn(
                'hover:bg-transparent',
                sortConfig?.field === 'sku' && 'font-bold'
              )}
            >
              SKU
              {sortConfig?.field === 'sku' && (
                <ArrowUpDown className={cn(
                  'ml-2 h-4 w-4',
                  sortConfig.direction === 'desc' && 'transform rotate-180'
                )} />
              )}
            </Button>
          </TableHead>
          <TableHead>
            <Button 
              variant="ghost" 
              onClick={() => onSort('name')}
              className={cn(
                'hover:bg-transparent',
                sortConfig?.field === 'name' && 'font-bold'
              )}
            >
              Name
              {sortConfig?.field === 'name' && (
                <ArrowUpDown className={cn(
                  'ml-2 h-4 w-4',
                  sortConfig.direction === 'desc' && 'transform rotate-180'
                )} />
              )}
            </Button>
          </TableHead>
          <TableHead>
            <Button 
              variant="ghost" 
              onClick={() => onSort('category')}
              className={cn(
                'hover:bg-transparent',
                sortConfig?.field === 'category' && 'font-bold'
              )}
            >
              Category
              {sortConfig?.field === 'category' && (
                <ArrowUpDown className={cn(
                  'ml-2 h-4 w-4',
                  sortConfig.direction === 'desc' && 'transform rotate-180'
                )} />
              )}
            </Button>
          </TableHead>
          <TableHead>
            <Button 
              variant="ghost" 
              onClick={() => onSort('price')}
              className={cn(
                'hover:bg-transparent',
                sortConfig?.field === 'price' && 'font-bold'
              )}
            >
              Price
              {sortConfig?.field === 'price' && (
                <ArrowUpDown className={cn(
                  'ml-2 h-4 w-4',
                  sortConfig.direction === 'desc' && 'transform rotate-180'
                )} />
              )}
            </Button>
          </TableHead>
          <TableHead>
            <Button 
              variant="ghost" 
              onClick={() => onSort('status')}
              className={cn(
                'hover:bg-transparent',
                sortConfig?.field === 'status' && 'font-bold'
              )}
            >
              Status
              {sortConfig?.field === 'status' && (
                <ArrowUpDown className={cn(
                  'ml-2 h-4 w-4',
                  sortConfig.direction === 'desc' && 'transform rotate-180'
                )} />
              )}
            </Button>
          </TableHead>
          <TableHead>Visibility</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {products.map((product) => (
          <TableRow key={product.id}>
            <TableCell>
              <Link 
                to={`/admin/products/${product.id}`}
                className="text-primary hover:underline"
              >
                {product.sku}
              </Link>
            </TableCell>
            <TableCell>{product.name}</TableCell>
            <TableCell>{product.category}</TableCell>
            <TableCell>${product.price.toFixed(2)}</TableCell>
            <TableCell>
              <Badge 
                variant={product.status === 'active' ? 'default' : 'secondary'}
              >
                {product.status}
              </Badge>
            </TableCell>
            <TableCell>
              <Badge 
                variant={product.isVisibleInCommerce ? 'success' : 'destructive'}
              >
                {product.isVisibleInCommerce ? 'Visible' : 'Hidden'}
              </Badge>
            </TableCell>
          </TableRow>
        ))}
        {products.length === 0 && (
          <TableRow>
            <TableCell colSpan={6} className="text-center py-8">
              No products found
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}

ProductsTable.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    sku: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
    isVisibleInCommerce: PropTypes.bool.isRequired
  })).isRequired,
  onSort: PropTypes.func.isRequired,
  sortConfig: PropTypes.shape({
    field: PropTypes.string.isRequired,
    direction: PropTypes.oneOf(['asc', 'desc']).isRequired
  })
}; 